import { Fragment, ReactNode } from 'react';

type SlotMap = Record<string, ReactNode>;

/**
 * Renders a template string with slots replaced by React nodes.
 */
export function RenderTemplate({
  template,
  slots,
  className,
}: {
  template: string;
  slots: SlotMap;
  className?: string;
}) {
  return (
    <span className={className}>
      {template.split(/(\{\{.*?\}\})/g).map((part) => {
        const match = part.match(/\{\{(.*?)\}\}/);
        if (!match) return part;

        const key = match[1];

        return <Fragment key={key}>{slots[key]}</Fragment>;
      })}
    </span>
  );
}
